var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H8C6.875 4 6 4.90625 6 6V18C6 19.125 6.875 20 8 20H16C17.0938 20 18 19.125 18 18V6C18 4.90625 17.0938 4 16 4ZM17 18C17 18.5625 16.5312 19 16 19H8C7.4375 19 7 18.5625 7 18V6C7 5.46875 7.4375 5 8 5H16C16.5312 5 17 5.46875 17 6V18ZM10.5 7H13.5C13.75 7 14 6.78125 14 6.5C14 6.25 13.75 6 13.5 6H10.5C10.2188 6 10 6.25 10 6.5C10 6.78125 10.2188 7 10.5 7ZM12 13.5C13.375 13.5 14.5 12.4062 14.5 11C14.5 9.625 13.375 8.5 12 8.5C10.5938 8.5 9.5 9.625 9.5 11C9.5 12.4062 10.5938 13.5 12 13.5ZM12 9.5C12.8125 9.5 13.5 10.1875 13.5 11C13.5 11.8438 12.8125 12.5 12 12.5C11.1562 12.5 10.5 11.8438 10.5 11C10.5 10.1875 11.1562 9.5 12 9.5ZM13.4375 14C12.8438 14 12.6875 14.2188 12 14.2188C11.2812 14.2188 11.125 14 10.5312 14C9.875 14 9.21875 14.3125 8.84375 14.875C8.625 15.2188 8.5 15.5938 8.5 16.0312V17.25C8.5 17.4062 8.59375 17.5 8.75 17.5H9.25C9.375 17.5 9.5 17.4062 9.5 17.25V16.0312C9.5 15.5938 9.78125 15 10.5312 15C10.9062 15 11.1875 15.2188 12 15.2188C12.7812 15.2188 13.0625 15 13.4375 15C14.2188 15 14.5 15.5938 14.5 16.0312V17.25C14.5 17.4062 14.5938 17.5 14.75 17.5H15.25C15.375 17.5 15.5 17.4062 15.5 17.25V16.0312C15.5 15.5938 15.3438 15.2188 15.125 14.875C14.75 14.3125 14.0938 14 13.4375 14Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.aaff5270.svg";
export { ForwardRef as ReactComponent };